function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.27539 6.87507C4.27539 5.88096 5.08128 5.07507 6.07539 5.07507H15.5254C16.5195 5.07507 17.3254 5.88096 17.3254 6.87507V13.6251C17.3254 14.6192 16.5195 15.4251 15.5254 15.4251H13.1629L10.8004 18.1251L8.43789 15.4251H6.07539C5.08128 15.4251 4.27539 14.6192 4.27539 13.6251V6.87507Z",
    stroke: "black",
    style: {
      stroke: "black",
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.55039 10.7C8.55039 10.9485 8.34892 11.15 8.10039 11.15C7.85186 11.15 7.65039 10.9485 7.65039 10.7C7.65039 10.4515 7.85186 10.25 8.10039 10.25C8.34892 10.25 8.55039 10.4515 8.55039 10.7Z",
    fill: "#8B8B8B",
    stroke: "black",
    style: {
      fill: "#8B8B8B",
      fill: "color(display-p3 0.5438 0.5438 0.5438)",
      fillOpacity: 1,
      stroke: "black",
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2496 10.7C11.2496 10.9485 11.0481 11.15 10.7996 11.15C10.5511 11.15 10.3496 10.9485 10.3496 10.7C10.3496 10.4515 10.5511 10.25 10.7996 10.25C11.0481 10.25 11.2496 10.4515 11.2496 10.7Z",
    fill: "#8B8B8B",
    stroke: "black",
    style: {
      fill: "#8B8B8B",
      fill: "color(display-p3 0.5438 0.5438 0.5438)",
      fillOpacity: 1,
      stroke: "black",
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9498 10.7C13.9498 10.9485 13.7483 11.15 13.4998 11.15C13.2513 11.15 13.0498 10.9485 13.0498 10.7C13.0498 10.4515 13.2513 10.25 13.4998 10.25C13.7483 10.25 13.9498 10.4515 13.9498 10.7Z",
    fill: "#8B8B8B",
    stroke: "black",
    style: {
      fill: "#8B8B8B",
      fill: "color(display-p3 0.5438 0.5438 0.5438)",
      fillOpacity: 1,
      stroke: "black",
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.e07b4493693bb2fe2e7093c62b9f93fb.svg";
export { ForwardRef as ReactComponent };